import endpoints from 'utils/api/endpoints';
import apiConfig from 'utils/api/config';
import { env } from 'config/app.config';

const OmanNetPaymentURLGenerator = (): string => {
	const url = endpoints.omantelApi.paymentSite.url;
	const protocol = apiConfig.protocol[env];
	const source = apiConfig.sources.omantelApi[env];
	return `${protocol}${source}${url}`;
};

const OmanNetPaymentURL = OmanNetPaymentURLGenerator();

/**
 * Redirects to payment redirection URL
 * @param url {string} - Payment redirection URL. Defaults to Omanet payment URL
 * Redirects the user to the specified payment redirection URL
 */
export const PaymentRedirection = (url?: string): void => {
	window.location.href = url ?? OmanNetPaymentURL;
};
